import { useState } from 'react';
import './index.css';

interface TeamMember {
  name: string;
  specialty: string;
  image: string;
}

const TEAM: TeamMember[] = [
  {
    name: 'Linda',
    specialty: 'Zobārsts',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Laura',
    specialty: 'Zobārsts, specializējas protezēšanā',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Anna',
    specialty: 'Zobārsts, specializējas protezēšanā',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Simona',
    specialty: 'Zobārsts',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Tatjana',
    specialty: 'Endodontists',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Irina',
    specialty: 'Zobārsts, specializējas endodontijā',
    image: '/images/anonymous_woman.jpg',
  },
  {
    name: 'Pēteris',
    specialty: 'Ortodonts',
    image: '/images/anonymous_man.jpg',
  },
  {
    name: 'Ojārs',
    specialty: 'Zobārsts, specializējas implantoloģijā',
    image: '/images/anonymous_man.jpg',
  },
  {
    name: 'Jānis',
    specialty: 'Zobārsts, specializējas implantoloģijā',
    image: '/images/anonymous_man.jpg',
  },
];

export const Team = () => {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <div className="team-page">
      <div className="team-header">
        <h1 className="team-title">Mūsu komanda</h1>
        <p className="team-subtitle">
          Iepazīsties ar mūsu kvalificētajiem un profesionālajiem speciālistiem!
        </p>
        <div className="section-divider" />
      </div>

      <div className="team-grid">
        {TEAM.map((member) => (
          <div
            key={member.name}
            className={`team-card ${hovered === member.name ? 'team-card--hovered' : ''}`}
            onMouseEnter={() => setHovered(member.name)}
            onMouseLeave={() => setHovered(null)}
          >
            <div className="team-card-image-wrap">
              <img
                className="team-card-image"
                src={member.image}
                alt={member.name}
                loading="lazy"
              />
            </div>
            <div className="team-card-body">
              <h2 className="team-card-name">{member.name}</h2>
              <p className="team-card-specialty">{member.specialty}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
